// @ts-nocheck
import React, {Fragment, PropsWithChildren} from "react";
import * as P from "../program-state"
import {Emit_main} from "../navigation";
import {Eres_card, Eres_iconbutton, Eres_warning_badge} from "../controls"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Link, useNavigate} from "react-router-dom"
import {custom_audience_t, brand_t} from "../resource/types"
import {z} from "zod"
import {faFacebook, faLinkedin, faTiktok, faXTwitter} from "@fortawesome/free-brands-svg-icons"
import {faPlus, faPencil, faTrash} from "@fortawesome/free-solid-svg-icons"


const add_comma = (number : number) => {
    if (number == null) {
        return ""
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


const get_brand = (brands: brand_t[], id: number | null) => {
    return brands && brands.find((item) => item.id == id)
}

type header_description = [string, string, string]

const Emit_header_column = ([key, label, width] : header_description) => {
    return <th key={key} className="tw-px-1.5 first:tw-ps-6 last:tw-pe-6 tw-py-4 tw-text-xs tw-font-bold tw-opacity-75" style={{width : width}}>{label}</th>
}

const Tablecol = ({children, align} : PropsWithChildren<{align? : "right"}>) => {
    return <td className={`tw-whitespace-nowrap tw-px-1.5 first:tw-ps-6 last:tw-pe-6 tw-py-1.5 tw-text-sm ${align === "right" ? "tw-text-right" : ""}`}>{children}</td>
}

const Emit_table_header = () => {
    const headers : header_description[] = [
        ["name"               , "Audience Name (estimate reach)"  , "40%"],
        ["associated_brand"   , "Associated brand"                 , "20%"],
        ["network"            , "Networks"                        , "25%"],
        ["created_at"         , "Created at"                      , "12%"],
        ["quickbuttons"       , " "                               , "1%" ],
    ]

    return (
        <thead className="tw-bg-gray-50">
        <tr className="">{headers.map((i) => Emit_header_column(i))}</tr>
        </thead>
    )
}


const count_audience_size_range = (data: audience_t) => {
    let lower_bound : number = 0;
    let upper_bound : number = 0;

    if (data.estimated_facebook_reach) {
      lower_bound += data.estimated_facebook_reach.users_lower_bound;
      upper_bound += data.estimated_facebook_reach.users_upper_bound;
    }

    if (data.estimated_linkedin_reach) {
      upper_bound += data.estimated_linkedin_reach.total;
    }

    if (data.estimated_tiktok_reach) {
      if (data.estimated_tiktok_reach.user_count) {
        lower_bound += data.estimated_tiktok_reach.user_count.lower_end;
        upper_bound += data.estimated_tiktok_reach.user_count.upper_end;
      }
    }

    return [lower_bound, upper_bound];
};


export const display_brand_name = (brands : brand_t[], audience : custom_audience_t) => {
    const brand : brand_t = get_brand(brands, audience.brand_id)
    return (
        <span>{brand?.name}</span>
    )
}


export const display_network_on_custom_audience = (audience : custom_audience_t) => {
    const has_facebook = audience?.facebook_audience != null;
    const has_linkedin = audience?.linkedin_audience != null;
    const has_tiktok = audience?.tiktok_audience != null;
    const has_x = audience?.x_audience != null;

    const has_any_network = has_facebook || has_linkedin || has_tiktok || has_x;

    return has_any_network ? (
        <div className="tw-flex tw-justify-left">
            <div className="tw-flex tw-justify-left tw-space-x-3">
              {has_facebook && (
                <div>
                    <FontAwesomeIcon icon={faFacebook} aria-hidden="true" title="Facebook" />
                </div>
              )}

              {has_linkedin && (
                <div>
                    <FontAwesomeIcon icon={faLinkedin} aria-hidden="true" title="LinkedIn" />
                </div>
              )}

              {has_tiktok && (
                <div>
                    <FontAwesomeIcon icon={faTiktok} aria-hidden="true" title="TikTok" />
                </div>
              )}

              {has_x && (
                <div>
                    <FontAwesomeIcon icon={faXTwitter} aria-hidden="true" title="X" />
                </div>
              )}
            </div>
        </div>
        ) : <Eres_warning_badge>None</Eres_warning_badge>;
}


export const display_estimated_audience_range = (audience: audience_t) => {
    const [lower_bound, upper_bound] = count_audience_size_range(audience);

    return (
        <p className="tw-text-green-700 tw-text-xs">Estimated audience size across networks: <span className="tw-text-green-900 tw-font-semibold">{add_comma(lower_bound)}</span> - <span className="tw-text-green-900 tw-font-semibold">{add_comma(upper_bound)}</span></p>
    )
}

export const Saved_audiences_table = ({audiences, onDeleteAudience} : {audiences: custom_audience_t[] | undefined, onDeleteAudience: (item: custom_audience_t) => Promise<void>}) => {
    const navigate = useNavigate()
    P.run_once_on_component_creation(() => void P.poll_connected_brands(ps, cs))
    const [brands, ps, cs] = P.use_brands()

    const drilldown_item = (item: custom_audience_t) => () => { navigate(`/custom-audiences/${item.id}`) }
    
    const delete_audience = React.useCallback((item: custom_audience_t) => async (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        
        if (!confirm(`Are you sure you want to delete the custom audience "${item.name}"? This action cannot be undone.`)) {
            return
        }
        
        await onDeleteAudience(item)
    }, [onDeleteAudience])

    return (
        <div className="tw-mt-3">
            <table className="tw-w-full tw-min-w-[800px] tw-border-y tw-mb-3 tw-table-auto">
                <Emit_table_header/>
                <tbody>
                    { audiences.map((audience) => 
                        <tr key={audience.id} className="tw-border-y tw-border-x-0 last:tw-border-b-0 hover:tw-bg-gray-50 hover:tw-cursor-pointer" onClick={drilldown_item(audience)}>
                            <Tablecol>
                                <div className="tw-text-base tw-text-big-stone-950 tw-font-semibold">{audience.name}</div>
                            </Tablecol>
                            <Tablecol>
                                {display_brand_name(brands, audience)}
                            </Tablecol>
                            <Tablecol>
                                {display_network_on_custom_audience(audience)}
                            </Tablecol>
                            <Tablecol>
                                4/10/2023
                            </Tablecol>
                            <Tablecol align="right">
                                <Link to={`/custom-audiences/${audience.id}`} onClick={(e) => e.stopPropagation()}><FontAwesomeIcon icon={faPencil} aria-hidden="true" className="tw-pe-1.5"/></Link>
                                <button type="button" onClick={delete_audience(audience)} className="tw-border-0 tw-bg-transparent tw-p-0 tw-cursor-pointer"><FontAwesomeIcon icon={faTrash} aria-hidden="true"/></button>
                            </Tablecol>
                        </tr>
                    ) }
                </tbody>
            </table>
            <div className="tw-pb-3 tw-px-6 tw-text-sm tw-text-lynch-600">
                {audiences.length} {audiences.length === 1 ? "entry" : "entries"}
            </div>

        </div>
    )
}

const Onboarding_banner = () => {
    const navigate = useNavigate();
    const [brands] = P.use_brands();
    const [connected_networks] = P.use_connected_networks();

    // Wait for data to load before showing banner
    if (brands === undefined || connected_networks === undefined) return null;

    const has_network = connected_networks.length > 0;
    const has_brand = brands.length > 0;
    const needs_onboarding = !has_network || !has_brand;

    if (!needs_onboarding) return null;

    return (
        <Eres_card className="tw-mb-4 tw-border-blue-200 tw-bg-blue-50">
            <div className="tw-p-4 tw-flex tw-items-center tw-justify-between">
                <div>
                    <p className="tw-font-semibold tw-text-blue-900">Complete your onboarding to create custom audiences</p>
                    <p className="tw-text-sm tw-text-blue-700">
                        {!has_network && !has_brand ? "Connect a social network and create a brand to upload custom audiences." :
                         !has_network ? "Connect a social network to upload custom audiences." :
                         "Create a brand to organize your custom audiences."}
                    </p>
                </div>
                <Eres_iconbutton onClick={() => navigate('/onboarding')}>
                    Continue onboarding
                </Eres_iconbutton>
            </div>
        </Eres_card>
    );
};

const Empty_state = () => {
    return (
        <div className="tw-text-center tw-py-12">
            <p className="tw-text-gray-600 tw-mb-4">No custom audiences yet</p>
            <p className="tw-text-sm tw-text-gray-500">Create your first custom audience by uploading a list of contacts</p>
        </div>
    );
};

const Audience_list_display = ({}) => {
    const [custom_audiences, ps, cs] = P.use_custom_audiences()
    P.run_once_on_component_creation(() => void P.poll_custom_audiences(ps, cs))

    const handleDeleteCustomAudience = React.useCallback(async (item: custom_audience_t) => {
        try {
            const [ok, resp] = await P.issue_json_delete(P.v1api`audiencesv2/custom-audiences/${item.id}`, z.any(), cs.token)
            if (ok) {
                // force immediate refresh
                const writableCs = cs as any
                writableCs.custom_audiences_last_update = 0
                void P.poll_custom_audiences(ps, cs)
            } else {
                console.error('Delete custom audience failed:', resp)

                // try to extract error message
                let errorMessage = 'Failed to delete custom audience. Please try again.'
                if (resp instanceof P.http_error) {
                    try {
                        const errorText = await resp.resp.text()
                        console.error('Backend error response:', errorText)

                        // check for foreign key constraint violations
                        if (errorText.includes('foreign key constraint') || errorText.includes('still referenced')) {
                            errorMessage = `Cannot delete this custom audience because it is being used by one or more campaigns. Please delete the campaigns first, then try again.`
                        } else {
                            // try to parse as JSON for other errors
                            try {
                                const errorData = JSON.parse(errorText)
                                if (errorData.detail && errorData.detail.message) {
                                    errorMessage = errorData.detail.message
                                }
                            } catch (jsonError) {
                                // use default message if JSON fails
                            }
                        }
                    } catch (parseError) {
                        console.error('Could not parse error response:', parseError)
                    }
                }

                alert(errorMessage)
            }
        } catch (error) {
            console.error('Error deleting custom audience:', error)
            alert('Failed to delete custom audience. Please try again.')
        }
    }, [ps, cs])

    return (
        <Fragment>
            <Onboarding_banner />
            <Eres_card>
                <div className="tw-mt-6 tw-px-6 tw-flex tw-flex-wrap">
                    <div className="tw-flex-grow">
                        <h3 className="tw-text-2xl tw-font-bold">Custom Audiences</h3>
                    </div>
                    <div className="tw-flex tw-flex-grow-0">
                        <Link to="/custom-audiences/create">
                            <Eres_iconbutton icon={faPlus} >Create Custom Audience</Eres_iconbutton>
                        </Link>
                    </div>
                </div>
                <div className="tw-overflow-x-auto">
                    { custom_audiences === undefined ? <p className="tw-p-6">Loading...</p> :
                      custom_audiences.length === 0 ? <Empty_state /> :
                      <Saved_audiences_table audiences={custom_audiences} onDeleteAudience={handleDeleteCustomAudience} /> }
                </div>
            </Eres_card>
        </Fragment>
    )
}

export default function Custom_audience_page() {

    return (
        <Emit_main page_id="PAGE-custom-audiences">
            <Audience_list_display />
        </Emit_main>
    )
}
